// src/blogData.js
const blogData = [
  {
  id: "on-longwencan-getting-married", // 文章的唯一ID (根据内容生成)
  title: "无题一", // 文章标题 (根据内容拟定)
  summary: "惊闻好友龙文灿婚讯，不禁回想起与他共度的初中、高中及毕业后的点滴时光，以及那份从NBA梦开始的深厚友谊。一篇非典型婚礼祝福，缅怀我们的青春。", // 文章摘要 (根据内容生成)
  content: `在大话西游之仙履奇缘中，当至尊宝得知紫霞嫁给牛魔王时的一脸惊讶就和我在朋友圈看到龙文灿结婚证时是一模一样的。我当时第一反应是他被盗号了。

“老婆？质量有我这个好？”

不服气，点进他的头像再三的确认，完了，真的是他。我当时第二反应是我这些年都做了些什么，为什么在我书都没有读完的时候人家已经可以合法同居，为什么在我觉得我还可以谈一百个女朋友的时候这个B人突然结婚，还可以做着一些可能创造小龙文灿的羞答答的事情。

讲三件事情

初中时候龙文灿，留着和我一样棱角分明的平头，眉宇间有着和我一样的忧郁，那个时候啥都不懂，天天盼着谁谁谁能帮从校外带份蛋炒饭，生物课到底什么时候才上生殖健康那堂课，我到底要怎么样才能装作老司机一样和女同学们讨论这些知识。

“什么是括约肌啊？”妹子扑闪着眼睛问道。
“掌握菊花的神”

而到了晚自习，总是发呆想自己什么时候能进NBA。在当时对友谊是没有明确的概念的，但是可以肯定的是，龙文灿是我的朋友，因为我俩都要进NBA。
“去湖人吧，湖人还可以。”
“肯定是尼克斯啊。”

别笑，这屌人肯定现在不承认。

初中的事情实在是太美好，哪怕是各种打架，矛盾，争吵也丝毫不影响那段岁月每一秒钟让我觉得珍贵。

高中时期的龙文灿陷入了一场爱恋。我了解的不多，但应该是那种愿意为她天天喊麦，刷飞机火箭送佛跳墙的那种深度。
“戎马一生为了谁，能爱几回我恨几回”
当然，在嫂子面前不承认，没有的事。MC灿一直是碰妹子的手都抖的像“情人”里梁家辉初见女主时一样，也绝不可能知道什么小泽玛利亚，天海翼之类杂七杂八的人。
然而高中怎么可能让你谈恋爱，曾培林眼睛眯着瞪你一眼，经都要绝了。每一对情侣都像是狼牙山五壮士一样，一旦老师哪天冲进教室指着他俩要他们出来谈话，转身就从窗外跳下去。

东风恶，欢情薄。 错，错，错。

现在想起来这应该是为什么情侣都坐在最远靠窗户的角落，方便。

我能怎么办嘛，我也很绝望啊，封心锁爱吧。

那个时候的我初看了教父三部曲，从老爸的蓝色芙蓉王里悄悄摸摸的抽出一根，学着艾尔帕其诺将脸隐藏在光明与黑暗之中然后把自己呛成老狗。还幻想着有一天能和我的偶像梁朝伟说，诺，这是我的本子，年华花样，拍不拍嘛。

去年夏天去了湘潭，喝了些酒，龙文灿发自肺腑的告诉我我们这些关系最铁的，常联系的兄弟也就这些了，很希望保持这份真挚的友谊。
当时他在当地摄影圈算是小有名气，不光技术高超，更是有摄影柳下惠之称。
而我和大多数成年雄性男子一样想着先读完书赶紧赚钱，比谁都想。
比谁都想有自己的个人独立影院，可以看很多的“我是古巴”这种装逼的片子。
比谁都想娶Gakki，最好胸还能再大一点的。
比谁都想打阿姆斯特朗回旋加速喷气式阿姆斯特朗炮。
这个在所有人生阶段都仿佛领先我一步的男人，最最最让我羡慕的是他能够干着自己最喜欢的事来养活自己，还有什么比这个更快乐呢？

“兄弟”

老子泪都快被勾下来了。

真的。

当然，我们之间是纯洁的同性友谊，尽管有时候喜欢用“我是你爷爷”之类的亲情来代替，但是情比金坚是从准备携手进入NBA就开始了。

那是很久以前了。

这些文字我写在一个离你大婚还有一个礼拜的周末，前面的project没有做完，后面的project又要来了。你的婚礼我是肯定赶不上了，很遗憾，自己的好兄弟的婚礼都不能参加。关于文风，你知道的，我这个人不喜欢煽情，即使煽情也要忙不迭的说几句骚话。如果觉得太骚了，还请宽恕则个。哈哈，老子最酷，你看过施瓦辛格一把鼻涕一把泪的吗？没有。

但是，我动的都是真情。

这篇文章严格意义上来说不是一篇祝贺你大婚的文章，它更多的是借此契机缅怀一下我和你的一部分青春以及追忆一下在快五年前我发在广播站的班级毕业稿。我现在还记得其中一句，白云真他妈苍狗。现在看依然如此。

特此插入那张至尊宝惊讶图

往事永远是美，苦也是美，谈情从来没道理。
此时此刻，想念整个学生时代的你，们。
新婚快乐。`, // 完整内容，保留了换行符
  date: "2017-03-19", // 您提供的日期
  tags: ["友谊", "青春", "回忆", "婚礼祝福"], // 根据内容建议的标签
  featuredImage: "/images/至尊宝惊讶图.jpg", // 假设图片名为这个，并放在 public/images/ 下。如果不是，请修改或告诉我。
  author: "Ji Cao" // 您提供的作者名
},
  {
  id: "sai-bian-da-wang", // 文章的唯一ID
  title: "腮边打网", // 文章标题
  summary: "与农场朋友阿牛的一席对话，关于失去、遗憾与成长。穿插着对阿菲的思念，对人生选择的感悟，以及在时代背景下对科比、疫情的追思与对未来的期盼。", // 文章摘要
  content: `住的地方对面的农场里养了一头牛。
我和他是好朋友。
每当很烦的时候，或者在夜深人静的时候我会悄悄地翻过栅栏去找他。

“阿菲已经两个礼拜没有回我了，我也好像对她没什么感觉了，害，就这样吧。”
“渣男，刚开始的时候叫人家小甜甜，现在说不喜欢就不喜欢。“
“……”我清了清嗓子，“其实，我现在想，这一开始或许就是个错误，我好像根本不了解她。”
“什么是了解？”阿牛撇着头看了我一眼。
“了解就是感同身受啊，就是明白一个人或者一件事啊。”
“你了解自己吗？“
我摇了摇头。
阿牛看着我笑。

我知道他在嘲笑我，但我哑口无言。

阿牛虽然比我小不少，但是好像比我懂太多，他总能精准分辨青草和菊苣以及鲁梅克斯，且优雅又不猥琐地盯着整个草坪最漂亮的奶牛，而从不脸红。比起牛，他的洒脱更像是一匹忧郁的安达卢西亚马，如梦似幻。我时常对他说，你有点小酷。
他说，我知道。

后来的我思忖万分，我觉得我对阿菲依然有感情。我给她发了很多信息，说来说去都是些腮边打网的话，拐弯抹角地告诉她失去之后才后悔莫及之类的话。我还买了很多她喜欢吃的零食送到她家的门口。我觉得这就是爱，只要她愿意，我可以日以继夜亘古不迭。我的眼泪可以像花洒一样随时为她而流。只是她再也没有说过Action。
再次见到阿牛的时候就是很久以后了。三月的天还是有些冷，晚上还总是起大雾。我翻过栅栏，吓了一跳。他身上被开了一个洞。
“操，你身上被人开了个洞。”我有点惊慌。
“操，真的假的？”阿牛也有点害怕。
我赶紧拍给他看。
“操，我就说最近怎么老感觉漏风。妈的，唉。其实我早就应该想到的。我虽然看不到自己身体，但是其实我早就看到别的牛身上开了洞。”
“我总是以为自己和别人不一样，总是像看穿开裆裤的小孩一样着看那些开了洞的傻牛。结果想不到我才是最惨的那个。

我们沉默了很久，都看着月亮不说话。后来我基于安慰人就要开始比惨的规矩开始和阿牛说起阿菲。
“前天阿菲终于接我电话了。”
“是吗？
“嗯。“
“她怎么说的？“
“不是她接的，是一个男人的声音。”
“哦，那有点惨的。” 阿牛开始安慰我，“没关系的，那个经常来农场骑马的小何其实也挺好的，就是头发好像有点少…”
“我还没说完。”我打断阿牛，说，“那个男的说今天是他和阿菲在一起的一百天纪念日，请我以后不要打扰她。”
“惨。”
“可是我好像和她分开才一个月不到。”
“别说了兄弟。”

“你知道吗，我可能快死了。他们都在传，身上打了洞之后就要被送去屠宰场。有人见过老一辈就这样没了的。“
我把手插进了口袋，不知道该说什么。
“你以后一定要死于意外啊，这种倒数日子的感觉生不如死。“
“呸呸呸。“
“你有空要替我去一趟怀俄明，哦对了，你知道怀俄明吗？“
我点了点头。
“那里有最大的野生野牛群。我一直觉得我是属于那儿的，只是可惜了，可惜这辈子都不出了这个鸟栅栏。你要是去了得帮我和他们问好，告诉他们请他们开心的生活，没有人会给你们打洞。”
我说，“嗯。”
“其实这么长时间以来农场主待我不薄，给吃给喝，除了打洞这事没提前通知我外，其他的无可厚非。他也不宰了我，他只是时不时地提醒我，按时吃草，早睡早起身体好，你没有别的选择。我就这么浑浑噩噩地度过了我的热血时期，被赶到东，被赶到西。现在我只想去草原上看看，就算黄沙吞没我。”
我一直没有说话。

做了最后的道别，我看了看他，准备转身离开。他叫住了我，说，“以后别你啊你的叫我，我其实有个英文名字，叫New。”
我说，“撒哟娜拉，New。”

大家好，我又回来了。转眼间又是一年的结尾了。
我其实还是有些抗拒这样写东西，一来是我不太喜欢为了写东西而写东西，二是因为懒。所以之所以这篇文章在新旧交接的时候才发出来不是因为旧历的年底毕竟最像年底，而是因为实在不知所措。
但这篇文章绝大部分还是在新年以前就写完了，紧接着就发生了很多事情，中东局势的剑拔弩张，肺炎的阴云笼罩，科比的坠机身亡。然后我开始后悔用悲伤的语调来写这篇故事，但是后来一想，这个故事其实是积极的。
提到科比我再多提一嘴。初中的时候很多人都喜欢科比，而我就偏要叛逆，于是我到哪我都说我不喜欢科比。结果到头来他的球衣照买，球鞋照穿，有他的比赛我还是会挤着头皮去看。来了洛杉矶总觉得即使他退役了但总有机会逮的到他吧，球鞋抢不到总还有复刻的吧，湖人总归是在的吧。不曾想要是人没了怎么办。
让子弹飞结尾处张麻子被问是不是喜欢花姐。我本以为的支支吾吾，结果在张麻子嘴里就六个字，“是有这么回事。”
这几个字其实是我去年文章的标题，不想一年过去了，我还是没改过来，还在学习表达的过程中挣扎。所以啊，诸位，别再扭扭捏捏了，快去对爱的人表达你的爱。

最后，为了证明牛会说话，特此附上家对面的农场图。:)

新年快乐，希望疫情早日过去，一起奔向未来的日子。
祝一切的一切都好。`, // 完整内容
  date: "2020-02-02", // 文章末尾提供的日期
  tags: ["随笔", "阿牛", "生活感悟", "遗憾"], // 根据内容建议的标签
  featuredImage: "/images/家对面的农场图.jpg", // 假设的特色图片路径，请您替换为实际路径
  author: "Ji Cao" // 文章末尾提供的作者名
},
 {
  id: "in-memory-of-tao-ranzhi", // 文章的唯一ID
  title: "然哥", // 文章标题
  summary: "世事总无常", // 文章摘要
  content: `我和然哥住一层楼，又是第一批认识的。自然感情比较深。我还记得我们在学校的第一周第一节课的作业就是一起做的。洛杉矶夏天的阳光让你半瞎不瞎，我两躲在室内总是想着法的偷懒。
“然哥你看，这个屌地方它是分为很多节的，每一节的长度大致相当。所以说我们只要量其中的一节然后乘以节数就行了。”
“好像还真是。那赶紧量吧，你来还是我来？”
“你来量，我来拍。你上镜。”
“那行吧，我们赶紧。但是别拍我脸啊。”
我肯定还是拍了然哥的脸。
偷懒方面然哥显然还是拿捏的更稳，拍完就要走。我拦住他，想再多偷点懒，去其他的地方再拍拍。我看他没答应，又赶紧说，没关系的，我也能拍，反正也没多少了。不料他想了想还是同意了。然后就这样在我的折磨下还是不免俗地把整个建筑从头到尾量了个遍，没有一句怨言。

住同一个公寓，同一层。不免在去上课的路上会偶尔碰到。有好几次看到然哥走在我前面，不远不近。近到可以看到他背包上的扣子，远到怎么叫他，他也没有反应。我不知道他在走路的时候同时在想什么，也不见他戴着耳机，被人问到可以打哈哈说音乐声太大。他总是喜欢走Aliso小区内的那条没有人的小道，从不东张西望，永远目视前方。

我的好朋友。
我深知人生无常，世事反复，人心云谲波诡。但不曾设想这些会发生在我身边。我笃信是缘分让我们一同开始这三年的旅程，自然我也从没怀疑任何人会中途离开这场游戏。从小到大我一直被灌输万事要坚持的观念。半途而废，激流勇退算是怎么回事。塔推了一半了要去挂机又算什么回事。
我多么希望你只是暂停了这场游戏然后微笑地和我们说，嘿嘿，我的机器出了问题，马上就回来。回来我们继续。
这件事多少让我开始反思。那些生活中的点点滴滴要是能再做的更好些，那些不知道从哪里来的坏情绪要是能再被表达地更柔软一些，对身边的人的关心能再更多一点。说不定会有不一样的结果。我要是对你关照地再积极一点，当你愁容满面地来问我怎么做模型的时候拍拍你的肩膀告诉你，没关系的，楼梯没建没关系的，我也没建的。动画不做没事的，老师不看这个的。会不会改变些什么。
有些时候我在房间里看着窗外蓝的可怕的天空然后又看看从早到晚目不转睛的电脑屏幕，竟会不时恍惚我现在究竟在干些什么。每每有人问我近况时，我总会马上让自己叹着气又装逼地说，“画图啊，还能干嘛？” 把对方硬邦邦地顶回去。我以为这样是提升自己的唯一途径。我以为我在成为所谓高尚的建筑师路上飞驰，我以为我要当知识分子了，然而往往有意识无意识地忽略了身边的很多事，错手于总体把控。看不到原来樱花早就谢了，下午四点的阳光居然这么刺眼了。生活竟然这样糟了。
我以为我会了，我觉得我行了。结果啥也不是，失去的反而更多。

然哥从来不争不抢也不见他发过脾气。设计做不出来了就摇摇头敲上朋友就去抽烟。他抽的烟很淡，我有几次给他芙蓉王他都摇摇头说这我来不了，太重了。我们笑他，你西北汉子这就重了？他也笑笑，不说话。他好几次和我说，这包抽完就真戒了。然而每每反悔。倘若你还在，想必你可能还是只是笑笑，一言不发。不过没关系的，抽吧，没关系的。

我的好朋友，好同学。我向你致以真正的最高的敬意。安息。`, // 完整内容
  date: "2020-05-09", // **请您替换为实际日期**
  tags: ["怀念", "友谊", "然哥", "生命", "遗憾", "反思"], // 根据内容建议的标签
  featuredImage: "/images/range.jpg", // 特色图片留空，您可以之后添加图片路径
  author: "Ji Cao" // 假设作者是您
}
  // 您可以在此添加更多博客文章...
  // 示例：
  // {
  //   id: "sustainable-architecture",
  //   title: "可持续建筑的未来趋势",
  //   summary: "探讨绿色建筑材料、节能设计以及建筑在应对气候变化中的角色。",
  //   content: `
  //     可持续建筑不再仅仅是一个口号，而是建筑行业发展的必然趋势。
  //     从被动式设计到主动式节能技术的应用，再到全生命周期的碳排放考量，未来的建筑将更加注重与环境的和谐共生。
  //     本文将介绍几种前沿的绿色建材，如菌丝体材料、回收塑料砖等，并分析它们在实际项目中的应用潜力...
  //   `,
  //   date: "2025-05-10",
  //   tags: ["可持续发展", "绿色建筑", "建筑科技"],
  //   featuredImage: "https://via.placeholder.com/400x250/3CB371/0B0C10?text=Sustainable+Arch",
  //   author: "您的名字"
  // }
];

export default blogData;